import Utility from "./Utility";
import Csv from "./Csv";
import { ObjViewer } from "./ObjViewer";
import { Trans } from "./Trans";
declare global {
    interface Window {
        tul_csv_table_working: boolean
        drupalSettings: {
            tulCsvTable: {
                translations: { [key: string]: string }
            }
        }
    }
}
function real_start() {
    let trans = Trans.getInstance();
    if (typeof window.drupalSettings !== "undefined") {
        console.info("drupalSettings detected, using it for translations");
        window.drupalSettings.tulCsvTable.translations = window.drupalSettings.tulCsvTable.translations || {};
        for (const [key, value] of Object.entries(window.drupalSettings.tulCsvTable.translations)) {
            trans.set_t(key, value);
        }
    } else {
        console.info("drupalSettings not detected, using default translations");
    }
    Utility.once_class(
        document.querySelectorAll(".tul-csv-table"),
        "tul-csv-table-initialized",
    ).forEach(function (csv_container) {
        csv_container.innerHTML = Utility.loaderHtml(trans.t("Loading file"));
        let attribNameDataCsvFile = "data-csv-file";
        if (csv_container.hasAttribute(attribNameDataCsvFile)) {
            let attribValueDataCsvFile = csv_container.getAttribute(
                attribNameDataCsvFile,
            );
            let dataCsvFileUrl = new URL(
                attribValueDataCsvFile as string,
                window.location.origin,
            );
            fetch(dataCsvFileUrl.toString())
                .catch((reason) => {
                    csv_container.innerHTML = Utility.errorHtml(
                        trans.t("Wystąpił problem z załadowaniem pliku"),
                    );
                })
                .then((response) => {
                    if (!(response instanceof Response)) {
                        return;
                    }
                    if (!response.ok) {
                        csv_container.innerHTML = Utility.errorHtml(
                            trans.t("Wystąpił problem z załadowaniem pliku"),
                        );
                        return;
                    }
                    response.text().then((body_text) => {
                        let data = Csv.parseCSV(body_text);
                        let objs = Csv.convertToObjectsFirstRowAsHeader(data);
                        let objViewerElement = document.createElement('div');
                        csv_container.innerHTML = "";
                        if (csv_container.hasAttribute('data-tul-csv-table-objviewer-skip-columns')) {
                            objViewerElement.setAttribute('data-tul-csv-table-objviewer-skip-columns', csv_container.getAttribute('data-tul-csv-table-objviewer-skip-columns') + "");
                        }
                        csv_container.appendChild(objViewerElement);
                        let objViewer = ObjViewer.getInstance(objViewerElement);
                        objViewer.data = objs;
                        // let table = Table.makeHtmlTable(data);
                        // csv_container.innerHTML = "";
                        // csv_container.appendChild(table);
                        // setTimeout(function () {
                        //     Table.comporessHtmlTable(table);
                        // }, 1);
                        // setTimeout(function () {
                        //     Table.detectColumnTypesForTable(table);
                        // }, 1);


                        // csv_container.innerHTML =
                        //   "<pre>" + JSON.stringify(data, null, 2) + "</pre>";
                    });
                });
        }
    });
}


function start() {
    if (window.tul_csv_table_working) {
        return;
    }
    window.tul_csv_table_working = true;
    real_start();
    window.tul_csv_table_working = false;
}
document.addEventListener("DOMContentLoaded", function () {
    start();
});

window.addEventListener("tul_csv_table_start", function () {
    start();
});

